/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import AutoAwesome from '@mui/icons-material/AutoAwesome';

import { MaterialIcon } from '../icons';
import { StyledCommandIntelligenceHeaderButton } from './CommandIntelligenceHeaderButton.styles';

const CommandIntelligenceHeaderButton = ({ onClick, title }) => {
  return (
    <div title={title}>
      <StyledCommandIntelligenceHeaderButton className="menu-icon-secondary" onClick={onClick}>
        <MaterialIcon icon={AutoAwesome} />
      </StyledCommandIntelligenceHeaderButton>
    </div>
  );
};

export default CommandIntelligenceHeaderButton;
